if (!customElements.get('image-with-text-accordion-images')) {
  customElements.define(
    'image-with-text-accordion-images',
    class ImageWithTextAccordionImages extends HTMLElement {
      connectedCallback() {
        this.images = Array.from(this.querySelectorAll('[data-accordion-image]'));
        this.triggers = Array.from(this.querySelectorAll('.accordion__item [data-collapsible-trigger]'));

        if (!this.images.length || !this.triggers.length) return;

        this.observer = new MutationObserver(() => this.updateImage());
        this.triggers.forEach((trigger) => {
          this.observer.observe(trigger, {
            attributes: true,
            attributeFilter: ['aria-expanded'],
          });
        });

        this.updateImage();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      updateImage() {
        const openTrigger = this.triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true');
        const imageId = openTrigger?.closest('.accordion__item')?.dataset.accordionImageId || 'default';
        const activeImage = this.images.find((image) => image.dataset.accordionImage === imageId)
          || this.images.find((image) => image.dataset.accordionImage === 'default');

        this.images.forEach((image) => {
          const isActive = image === activeImage;
          image.classList.toggle('is-active', isActive);
          image.setAttribute('aria-hidden', String(!isActive));
        });
      }
    }
  );
}
